import ApiService from "@/common/api.service";

const PATH = "stock/invoices";

export const GET_STOCK_INVOICE_TYPES = "getStockInvoiceTypes";
export const GET_STOCK_INVOICE_DIRECTIONS = "getStockInvoiceDirections";
export const GET_STOCK_INVOICE_STATUSES = "getStockInvoiceStatuses";
export const GET_STOCK_NOT_INVOICED_ACTIONS = "getStockNotInvoicedActions";
export const GET_STOCK_INVOICES = "getStockInvoices";
export const EXPORT_STOCK_INVOICES = "exportStockInvoices";
export const GET_STOCK_INVOICE = "getStockInvoice";
export const CREATE_STOCK_INVOICE = "createStockInvoice";
export const UPDATE_STOCK_INVOICE = "updateStockInvoice";
export const ISSUE_STOCK_INVOICE = "issueStockInvoice";
export const CANCEL_STOCK_INVOICE = "cancelStockInvoice";
export const LOCK_STOCK_INVOICE = "lockStockInvoice";
export const MERGE_STOCK_INVOICE_LINES = "mergeStockInvoiceLines";
export const ADD_STOCK_INVOICE_ACTIONS = "addStockInvoiceActions";
export const REMOVE_STOCK_INVOICE_ACTIONS = "removeStockInvoiceActions";
export const GET_STOCK_INVOICE_ACTION_LINK_OPTIONS = "getStockInvoiceActionLinkOptions";
export const GET_STOCK_INVOICE_DELIVERY_NOTE_LINK_OPTIONS = "getStockInvoiceDeliveryNoteLinkOptions";
export const CREATE_STOCK_INVOICE_FROM_DELIVERIES = "createStockInvoiceFromDeliveries";
export const CREATE_STOCK_INVOICE_FROM_RECEIPTS = "createStockInvoiceFromReceipts";
export const CREATE_STOCK_PROFORMA_FROM_SALES_ORDER = "createProformaFromSalesOrder";
export const CREATE_STOCK_INVOICE_FROM_RECEIPT = "createStockInvoiceFromReceipt";
export const CREATE_STOCK_INVOICE_FROM_EXTRA_COST = "createStockInvoiceFromExtraCost";
export const CREATE_STOCK_CREDIT_NOTE = "createStockCreditNote";
export const CREATE_INVOICE_FROM_PROFORMA = "createInvoiceFromProforma";
export const CLONE_STOCK_INVOICE = "cloneStockInvoice";
export const CREATE_STOCK_DEBIT_NOTE = "createStockDebitNote";
export const UPLOAD_STOCK_INVOICE_FILES = "uploadStockInvoiceFiles";
export const DELETE_STOCK_INVOICE_FILE = "deleteStockInvoiceFile";
export const DOWNLOAD_STOCK_INVOICE_FILE = "downloadStockInvoiceFile";
export const REGENERATE_STOCK_INVOICE_DOCUMENT = "regenerateStockInvoiceDocument";
export const GET_ORGANIZATION_BANK_ACCOUNTS = "getOrganizationBankAccounts";
export const GET_INVOICE_PAYMENT_TERM_SNIPPETS = "getInvoicePaymentTermSnippets";
export const RECORD_STOCK_INVOICE_PAYMENT = "recordStockInvoicePayment";
export const CANCEL_STOCK_INVOICE_PAYMENT = "cancelStockInvoicePayment";
export const RECORD_STOCK_INVOICE_EMAIL_SEND = "recordStockInvoiceEmailSend";
export const DOWNLOAD_STOCK_INVOICE_EMAIL_SEND = "downloadStockInvoiceEmailSend";

const actions = {
  [GET_STOCK_INVOICE_TYPES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/invoice-types")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVOICE_DIRECTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/invoice-directions")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVOICE_STATUSES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/invoice-statuses")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_NOT_INVOICED_ACTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/not-invoiced-actions`, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVOICES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [EXPORT_STOCK_INVOICES](context, params) {
    const date = new Date().toISOString().slice(0, 10);

    return new Promise((resolve, reject) => {
      ApiService.downloadQuery(
        `${PATH}/export`,
        {
          ...(params || {}),
          ...context.rootGetters.stockContextFilterParams,
        },
        `invoices-${date}.xlsx`
      )
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVOICE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_INVOICE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_INVOICE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [ISSUE_STOCK_INVOICE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/issue`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_INVOICE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [LOCK_STOCK_INVOICE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/lock`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [MERGE_STOCK_INVOICE_LINES](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/merge-lines`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [ADD_STOCK_INVOICE_ACTIONS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/add-actions`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REMOVE_STOCK_INVOICE_ACTIONS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/remove-actions`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVOICE_ACTION_LINK_OPTIONS](context, actionId) {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/actions", `${actionId}/invoice-link-options`)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_INVOICE_DELIVERY_NOTE_LINK_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/invoices/delivery-note-link-options", params || {})
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_INVOICE_FROM_DELIVERIES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/create-from-deliveries`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_INVOICE_FROM_RECEIPTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/create-from-receipts`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_PROFORMA_FROM_SALES_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `stock/sales-orders/${payload.salesOrderId}/create-proforma-invoice`,
        payload.params || {}
      )
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_INVOICE_FROM_RECEIPT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `stock/receipts/${payload.receiptId}/create-invoice`,
        payload.params || {}
      )
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_INVOICE_FROM_EXTRA_COST](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `stock/extra-costs/${payload.extraCostId}/create-invoice`,
        payload.params || {}
      )
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_CREDIT_NOTE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-credit-note`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_INVOICE_FROM_PROFORMA](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-invoice-from-proforma`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CLONE_STOCK_INVOICE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/clone`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_DEBIT_NOTE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-debit-note`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_INVOICE_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_INVOICE_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_INVOICE_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [REGENERATE_STOCK_INVOICE_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_ORGANIZATION_BANK_ACCOUNTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/organization-bank-accounts", params || {})
        .then(({ data }) => resolve(data.data || data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_INVOICE_PAYMENT_TERM_SNIPPETS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/invoice-payment-term-snippets", params || {})
        .then(({ data }) => resolve(data.data || data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [RECORD_STOCK_INVOICE_PAYMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/record-payment`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_INVOICE_PAYMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/payments/${payload.paymentId}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [RECORD_STOCK_INVOICE_EMAIL_SEND](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/email-sends`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_INVOICE_EMAIL_SEND](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/email-sends/${payload.sendId}/pdf`,
        payload.originalName || "invoice.pdf"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
